
import {
  Component,
  OnInit,
  HostListener,
  ChangeDetectorRef
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

import {
  AvaliacaoService,
  AvaliacaoPublica
} from '../../service/avaliacao.service';

import {
  QuartoService,
  Quarto
} from '../../service/quarto.service';

import {
  CheckoutService,
  ReservaCalendario
} from '../../service/checkout.service';



import { AnalyticsService } from '../../service/analytics.service';
import {RegraMinimoNoites, RegrasMinimoNoitesService} from '../../service/RegraMinimoNoites.service';

interface DiaCalendario {
  numero: number;
  data: Date;
  mesAtual: boolean;
  hoje: boolean;
  selecionado: boolean;
  intervalo: boolean;
  desabilitado: boolean;
}

@Component({
  selector: 'app-cabana-ype',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cabana-ype.component.html',
  styleUrl: './cabana-ype.component.css'
})
export class CabanaYpeComponent implements OnInit {

  readonly quartoId = 1;

  quarto: Quarto | null = null;

  avaliacoes: AvaliacaoPublica[] = [];

  reservasOcupadas: ReservaCalendario[] = [];

  regrasMinimoNoites: RegraMinimoNoites[] = [];

  carregandoCalendario = true;
  erroCalendario = false;

  private regrasCarregadas = false;
  private reservasCarregadas = false;

  imagensCabana: string[] = [
    '/cabana-ype.PNG',
    '/cabana-ype-2.PNG',
    '/cabana-ype-3.PNG',
    '/cabana-ype-4.PNG',
    '/cabana-ype-5.PNG',
    '/cabana-ype-6.PNG',
    '/cabana-ype-7.PNG',
    '/cabana-ype-8.PNG',
    '/cabana-ype-9.PNG',
    '/cabana-ype-10.PNG',
    '/cabana-ype-11.PNG',
    '/cabana-ype-12.PNG',
    '/cabana-ype-13.PNG',
    '/cabana-ype-14.PNG',
    '/cabana-ype-15.PNG',
    '/cabana-ype-16.PNG',
    '/cabana-ype-17.PNG',
    '/cabana-ype-18.PNG',
    '/cabana-ype-19.PNG',
    '/cabana-ype-20.PNG',
    '/cabana-ype-21.PNG',
    '/cabana-ype-22.PNG',
    '/cabana-ype-23.PNG',
    '/cabana-ype-24.PNG',
    '/cabana-ype-25.PNG',
    '/cabana-ype-26.PNG',
    '/cabana-ype-27.PNG',
    '/cabana-ype-28.PNG',
    '/cabana-ype-29.PNG',
    '/cabana-ype-30.PNG',
    '/cabana-ype-31.PNG',
    '/cabana-ype-32.PNG',
    '/cabana-ype-33.PNG',
    '/cabana-ype-34.PNG',
    '/cabana-ype-35.PNG',
    '/cabana-ype-36.PNG',
    '/cabana-ype-37.PNG',
    '/cabana-ype-38.PNG',
    '/cabana-ype-39.jpeg',
    '/cabana-ype-40.jpeg',
    '/cabana-ype-41.PNG',
    '/cabana-ype-42.jpeg',
    '/cabana-ype-43.jpeg',
    '/cabana-ype-44.jpeg',
    '/cabana-ype-45.jpeg',
    '/cabana-ype-46.jpeg',
    '/cabana-ype-47.jpeg',
    '/cabana-ype-48.jpeg',
    '/cabana-ype-49.jpeg',
    '/cabana-ype-50.jpeg',
    '/cabana-ype-51.jpeg',
    '/cabana-ype-52.jpeg',
    '/cabana-ype-53.jpeg',
    '/cabana-ype-54.jpeg',
    '/cabana-ype-55.jpeg',
    '/cabana-ype-56.jpeg'
  ];

  indiceImagem = 0;

  dataEntrada: Date | null = null;
  dataSaida: Date | null = null;

  adultos = 0;
  criancas = 0;
  animais = 0;

  mostrarHospedes = false;
  mostrarCalendario = false;

  modoCalendario: 'entrada' | 'saida' = 'entrada';

  processando = false;

  dataCalendario = new Date();

  mesAtual = this.dataCalendario.getMonth();
  anoAtual = this.dataCalendario.getFullYear();

  diasCalendario: DiaCalendario[] = [];

  nomesMeses = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro'
  ];

  constructor(
    private quartoService: QuartoService,
    private checkoutService: CheckoutService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private avaliacaoService: AvaliacaoService,
    private analyticsService: AnalyticsService,
    private regrasMinimoNoitesService: RegrasMinimoNoitesService
  ) {}

  // =====================================================
  // INICIALIZAÇÃO
  // =====================================================

  ngOnInit(): void {

    this.analyticsService.quartoVisualizado(
      'Cabana Ypê',
      this.quartoId
    );

    this.carregarQuarto();
    this.carregarDadosReserva();
    this.carregarAvaliacoes();

    this.carregarDatasOcupadas();
    this.carregarRegrasMinimoNoites();

    this.irParaMesDataMinima();
    this.gerarCalendario();
  }

  // =====================================================
  // REGRAS DE MÍNIMO DE NOITES
  // =====================================================

  private carregarRegrasMinimoNoites(): void {

    this.regrasCarregadas = false;
    this.carregandoCalendario = true;

    this.regrasMinimoNoitesService
      .listarPublicas(this.quartoId)
      .subscribe({

        next: (regras) => {

          this.regrasMinimoNoites = regras ?? [];
          this.regrasCarregadas = true;

          this.finalizarCarregamentoCalendario();
        },

        error: () => {

          this.regrasCarregadas = false;
          this.erroCalendario = true;
          this.carregandoCalendario = false;

          this.gerarCalendario();
          this.cdr.detectChanges();

          this.mostrarAlerta(
            'error',
            'Erro ao carregar regras',
            'Não foi possível consultar as regras de mínimo de noites da Cabana Ypê.'
          );
        }
      });
  }

  private obterMinimoNoites(data: Date): number {

    const dataString = this.formatarDataBackend(data);

    const regra = this.regrasMinimoNoites.find(
      regra =>
        regra.data === dataString &&
        regra.ativo === true
    );

    return Math.max(1, Number(regra?.minimoNoites ?? 1));
  }

  get minimoNoitesSelecionado(): number {

    if (!this.dataEntrada) {
      return 1;
    }

    return this.obterMinimoNoites(this.dataEntrada);
  }

  private calcularCheckoutMinimo(entrada: Date): Date {

    const checkout = this.normalizarData(entrada);

    checkout.setDate(
      checkout.getDate() + this.obterMinimoNoites(entrada)
    );

    return checkout;
  }

  get checkoutMinimo(): Date | null {

    if (!this.dataEntrada) {
      return null;
    }

    return this.calcularCheckoutMinimo(this.dataEntrada);
  }

  // =====================================================
  // CARREGAMENTO DAS DATAS OCUPADAS
  // =====================================================

  private carregarDatasOcupadas(): void {

    this.reservasCarregadas = false;
    this.carregandoCalendario = true;

    this.checkoutService
      .buscarDatasOcupadas(this.quartoId)
      .subscribe({

        next: (reservas) => {

          this.reservasOcupadas = reservas ?? [];
          this.reservasCarregadas = true;

          this.finalizarCarregamentoCalendario();
        },

        error: () => {

          this.reservasCarregadas = false;
          this.erroCalendario = true;
          this.carregandoCalendario = false;

          this.gerarCalendario();
          this.cdr.detectChanges();

          this.mostrarAlerta(
            'error',
            'Erro ao carregar disponibilidade',
            'Não foi possível consultar as datas ocupadas da Cabana Ypê.'
          );
        }
      });
  }

  private finalizarCarregamentoCalendario(): void {

    if (
      this.erroCalendario ||
      !this.regrasCarregadas ||
      !this.reservasCarregadas
    ) {
      return;
    }

    this.carregandoCalendario = false;

    this.validarDatasRecuperadas();

    this.gerarCalendario();
    this.cdr.detectChanges();
  }

  private validarDatasRecuperadas(): void {

    if (!this.dataEntrada) {
      this.dataSaida = null;
      return;
    }

    if (
      this.dataEntrada < this.dataMinimaDate ||
      this.dataEstaOcupada(this.dataEntrada)
    ) {

      this.dataEntrada = null;
      this.dataSaida = null;

      return;
    }

    if (!this.dataSaida) {
      return;
    }

    const checkoutMinimo = this.checkoutMinimo;

    if (
      !checkoutMinimo ||
      this.dataSaida < checkoutMinimo ||
      this.periodoPossuiConflito(
        this.dataEntrada,
        this.dataSaida
      )
    ) {

      this.dataSaida = null;
    }
  }

  // =====================================================
  // QUARTO E AVALIAÇÕES
  // =====================================================

  carregarQuarto(): void {

    this.quartoService
      .buscarPorId(this.quartoId)
      .subscribe({

        next: (quarto) => {

          this.quarto = quarto;
          this.cdr.detectChanges();
        },

        error: () => {

          this.mostrarAlerta(
            'error',
            'Erro',
            'Não foi possível carregar os dados da cabana.'
          );
        }
      });
  }

  private carregarAvaliacoes(): void {

    this.avaliacaoService
      .buscarAvaliacoesPublicas(this.quartoId)
      .subscribe({

        next: (avaliacoes) => {

          this.avaliacoes = avaliacoes ?? [];
          this.cdr.detectChanges();
        },

        error: () => {

          this.avaliacoes = [];
          this.cdr.detectChanges();
        }
      });
  }

  get mediaAvaliacoes(): number {

    if (this.avaliacoes.length === 0) {
      return 0;
    }

    const total = this.avaliacoes.reduce(
      (soma, avaliacao) => soma + avaliacao.nota,
      0
    );

    return total / this.avaliacoes.length;
  }

  // =====================================================
  // DADOS RECUPERADOS DO CHECKOUT
  // =====================================================

  private carregarDadosReserva(): void {

    const dados = this.checkoutService.obter();

    if (!dados || dados.quartoId !== this.quartoId) {
      return;
    }

    if (dados.checkIn) {
      this.dataEntrada = this.converterData(dados.checkIn);
    }

    if (dados.checkOut) {
      this.dataSaida = this.converterData(dados.checkOut);
    }

    if (dados.adultos !== undefined) {
      this.adultos = dados.adultos;
    }

    if (dados.criancas !== undefined) {
      this.criancas = dados.criancas;
    }

    if (dados.animais !== undefined) {
      this.animais = Math.max(
        0,
        Math.min(2, Number(dados.animais) || 0)
      );
    }if (dados.animais !== undefined) {
      this.animais = dados.animais;
    }
  }

  private converterData(data: string): Date {

    const partes = data.split('-').map(Number);

    return new Date(
      partes[0],
      partes[1] - 1,
      partes[2]
    );
  }

  // =====================================================
  // GALERIA DE IMAGENS
  // =====================================================

  get imagensVisiveis(): string[] {

    return this.imagensCabana.slice(
      this.indiceImagem,
      this.indiceImagem + 3
    );
  }

  get totalPaginasGaleria(): number {

    return Math.ceil(this.imagensCabana.length / 3);
  }

  get paginaGaleriaAtual(): number {

    return Math.floor(this.indiceImagem / 3);
  }

  imagemAnterior(): void {

    const indiceAnterior = this.indiceImagem - 3;

    if (indiceAnterior < 0) {

      this.indiceImagem =
        (this.totalPaginasGaleria - 1) * 3;

    } else {

      this.indiceImagem = indiceAnterior;
    }
  }

  proximaImagem(): void {

    const proximoIndice = this.indiceImagem + 3;

    if (proximoIndice >= this.imagensCabana.length) {

      this.indiceImagem = 0;

    } else {

      this.indiceImagem = proximoIndice;
    }
  }

  selecionarImagem(pagina: number): void {

    const novoIndice = pagina * 3;

    if (novoIndice < this.imagensCabana.length) {
      this.indiceImagem = novoIndice;
    }
  }

  // =====================================================
  // HÓSPEDES
  // =====================================================

  get totalHospedes(): number {

    return this.adultos + this.criancas;
  }

  alterarHospedes(
    tipo: 'adultos' | 'criancas' | 'animais',
    valor: number
  ): void {

    switch (tipo) {

      case 'adultos': {

        const novoValor = Math.max(
          1,
          this.adultos + valor
        );

        if (
          valor > 0 &&
          this.quarto &&
          novoValor + this.criancas > this.quarto.capacidade
        ) {

          this.mostrarAlerta(
            'warning',
            'Capacidade excedida',
            `Esta acomodação permite no máximo ${this.quarto.capacidade} hóspedes.`
          );

          return;
        }

        this.adultos = novoValor;
        break;
      }

      case 'criancas': {

        const novoValor = Math.max(
          0,
          this.criancas + valor
        );

        if (
          valor > 0 &&
          this.quarto &&
          this.adultos + novoValor > this.quarto.capacidade
        ) {

          this.mostrarAlerta(
            'warning',
            'Capacidade excedida',
            `Esta acomodação permite no máximo ${this.quarto.capacidade} hóspedes.`
          );

          return;
        }

        this.criancas = novoValor;
        break;
      }

      case 'animais': {

        this.animais = Math.max(
          0,
          Math.min(2, this.animais + valor)
        );

        break;
      }
    }
  }

  toggleHospedes(): void {

    this.mostrarHospedes = !this.mostrarHospedes;
    this.mostrarCalendario = false;
  }

  // =====================================================
  // ABRIR E FECHAR CALENDÁRIO
  // =====================================================

  @HostListener('document:click', ['$event'])
  fecharMenusAoClicarFora(event: MouseEvent): void {

    const elemento = event.target as HTMLElement;

    const clicouDentroDoCalendario =
      elemento.closest('.calendario');

    const clicouDentroDosHospedes =
      elemento.closest('.hospedes-dropdown');

    const clicouNoBotaoCalendario =
      elemento.closest('.campo-botao');

    if (
      clicouDentroDoCalendario ||
      clicouDentroDosHospedes ||
      clicouNoBotaoCalendario
    ) {
      return;
    }

    this.mostrarCalendario = false;
    this.mostrarHospedes = false;
  }

  abrirCalendario(modo: 'entrada' | 'saida'): void {

    if (
      this.carregandoCalendario ||
      this.erroCalendario
    ) {

      this.mostrarAlerta(
        'warning',
        'Calendário indisponível',
        'Não foi possível concluir o carregamento da disponibilidade e das regras.'
      );

      return;
    }

    // Sem entrada, a seleção deve começar pelo check-in.
    if (modo === 'saida' && !this.dataEntrada) {

      this.modoCalendario = 'entrada';
      this.irParaMesDataMinima();

    } else {

      this.modoCalendario = modo;

      if (modo === 'entrada') {

        if (this.dataEntrada) {

          this.mesAtual = this.dataEntrada.getMonth();
          this.anoAtual = this.dataEntrada.getFullYear();

        } else {

          this.irParaMesDataMinima();
        }

      } else if (this.dataEntrada) {

        const minimo = this.checkoutMinimo!;

        this.mesAtual = minimo.getMonth();
        this.anoAtual = minimo.getFullYear();
      }
    }

    this.mostrarCalendario = true;
    this.mostrarHospedes = false;

    this.gerarCalendario();
  }

  get dataMinimaDate(): Date {

    const hoje = this.normalizarData(new Date());

    hoje.setDate(hoje.getDate() + 1);

    return hoje;
  }

  get dataMinima(): string {

    return this.formatarDataBackend(this.dataMinimaDate);
  }

  private irParaMesDataMinima(): void {

    const minimo = this.dataMinimaDate;

    this.mesAtual = minimo.getMonth();
    this.anoAtual = minimo.getFullYear();
  }

  // =====================================================
  // GERAÇÃO DO CALENDÁRIO
  // =====================================================

  gerarCalendario(): void {

    const primeiroDia = new Date(
      this.anoAtual,
      this.mesAtual,
      1
    );

    const ultimoDia = new Date(
      this.anoAtual,
      this.mesAtual + 1,
      0
    );

    const dias: DiaCalendario[] = [];

    const primeiroDiaSemana = primeiroDia.getDay();

    for (let i = 0; i < primeiroDiaSemana; i++) {

      dias.push({
        numero: 0,
        data: new Date(0),
        mesAtual: false,
        hoje: false,
        selecionado: false,
        intervalo: false,
        desabilitado: true
      });
    }

    for (let i = 1; i <= ultimoDia.getDate(); i++) {

      const data = new Date(
        this.anoAtual,
        this.mesAtual,
        i
      );

      dias.push(this.criarDia(data, true));
    }

    this.diasCalendario = dias;
  }

  criarDia(
    data: Date,
    mesAtual: boolean
  ): DiaCalendario {

    const dataSemHora = this.normalizarData(data);
    const hoje = this.normalizarData(new Date());

    const selecionado =
      this.mesmaData(dataSemHora, this.dataEntrada) ||
      this.mesmaData(dataSemHora, this.dataSaida);

    const intervalo =
      this.dataEntrada !== null &&
      this.dataSaida !== null &&
      dataSemHora > this.normalizarData(this.dataEntrada) &&
      dataSemHora < this.normalizarData(this.dataSaida);

    let desabilitado =
      !mesAtual ||
      dataSemHora < this.dataMinimaDate ||
      this.carregandoCalendario ||
      this.erroCalendario;

    if (this.modoCalendario === 'entrada') {

      // Check-in não pode ocorrer em dia ocupado.
      if (this.dataEstaOcupada(dataSemHora)) {
        desabilitado = true;
      }

      // Uma data de check-in com regra especial também
      // precisa ter espaço para cumprir o mínimo de noites.
      const checkoutMinimo =
        this.calcularCheckoutMinimo(dataSemHora);

      if (
        this.periodoPossuiConflito(
          dataSemHora,
          checkoutMinimo
        )
      ) {
        desabilitado = true;
      }

    } else if (this.modoCalendario === 'saida') {

      if (!this.dataEntrada) {

        desabilitado = true;

      } else {

        const entrada = this.normalizarData(
          this.dataEntrada
        );

        const checkoutMinimo = this.checkoutMinimo;

        if (
          dataSemHora <= entrada ||
          (checkoutMinimo && dataSemHora < checkoutMinimo)
        ) {

          desabilitado = true;

        } else if (
          this.periodoPossuiConflito(
            entrada,
            dataSemHora
          )
        ) {

          desabilitado = true;
        }
      }
    }

    return {
      numero: data.getDate(),
      data,
      mesAtual,
      hoje: this.mesmaData(dataSemHora, hoje),
      selecionado,
      intervalo,
      desabilitado
    };
  }

  // =====================================================
  // CONFLITOS DE RESERVAS
  // =====================================================

  private dataEstaOcupada(data: Date): boolean {

    const dataString = this.formatarDataBackend(data);

    return this.reservasOcupadas.some(
      reserva =>
        dataString >= reserva.checkIn &&
        dataString < reserva.checkOut
    );
  }

  private periodoPossuiConflito(
    entrada: Date,
    saida: Date
  ): boolean {

    const entradaString =
      this.formatarDataBackend(entrada);

    const saidaString =
      this.formatarDataBackend(saida);

    return this.reservasOcupadas.some(
      reserva =>
        entradaString < reserva.checkOut &&
        saidaString > reserva.checkIn
    );
  }

  // =====================================================
  // SELEÇÃO DE DATAS
  // =====================================================

  selecionarData(dia: DiaCalendario): void {

    if (
      dia.numero === 0 ||
      dia.desabilitado ||
      this.carregandoCalendario ||
      this.erroCalendario
    ) {
      return;
    }

    const dataSelecionada = this.normalizarData(dia.data);

    if (this.modoCalendario === 'entrada') {

      const checkoutMinimo =
        this.calcularCheckoutMinimo(dataSelecionada);

      if (
        this.dataEstaOcupada(dataSelecionada) ||
        this.periodoPossuiConflito(
          dataSelecionada,
          checkoutMinimo
        )
      ) {

        this.mostrarAlerta(
          'warning',
          'Check-in indisponível',
          'Não há noites disponíveis suficientes para iniciar uma reserva nesta data.'
        );

        return;
      }

      this.dataEntrada = dataSelecionada;
      this.dataSaida = null;

      this.modoCalendario = 'saida';

      // Se o checkout mínimo estiver em outro mês,
      // abre o mês em que ele passa a ser permitido.
      this.mesAtual = checkoutMinimo.getMonth();
      this.anoAtual = checkoutMinimo.getFullYear();

      this.gerarCalendario();
      this.cdr.detectChanges();

      return;
    }

    if (!this.dataEntrada) {
      return;
    }

    const checkoutMinimo = this.checkoutMinimo;

    if (
      !checkoutMinimo ||
      dataSelecionada < checkoutMinimo
    ) {

      this.mostrarAlerta(
        'warning',
        'Estadia mínima',
        `Esta data exige pelo menos ${this.minimoNoitesSelecionado} noites.`
      );

      return;
    }

    if (
      this.periodoPossuiConflito(
        this.dataEntrada,
        dataSelecionada
      )
    ) {

      this.mostrarAlerta(
        'error',
        'Período indisponível',
        'Existe uma reserva ocupando parte do período selecionado.'
      );

      return;
    }

    this.dataSaida = dataSelecionada;

    this.analyticsService.datasSelecionadas(
      this.quartoId,
      this.formatarDataBackend(this.dataEntrada),
      this.formatarDataBackend(this.dataSaida)
    );

    this.mostrarCalendario = false;

    this.gerarCalendario();
    this.cdr.detectChanges();
  }

  // =====================================================
  // NAVEGAÇÃO ENTRE MESES
  // =====================================================

  mesAnterior(): void {

    const minimo = this.dataMinimaDate;

    if (
      this.anoAtual < minimo.getFullYear()
    ) {
      return;
    }

    if (
      this.anoAtual === minimo.getFullYear() &&
      this.mesAtual <= minimo.getMonth()
    ) {
      return;
    }

    this.mesAtual--;

    if (this.mesAtual < 0) {
      this.mesAtual = 11;
      this.anoAtual--;
    }

    this.gerarCalendario();
  }

  mesProximo(): void {

    this.mesAtual++;

    if (this.mesAtual > 11) {
      this.mesAtual = 0;
      this.anoAtual++;
    }

    this.gerarCalendario();
  }

  // =====================================================
  // UTILITÁRIOS DE DATAS
  // =====================================================

  private normalizarData(data: Date): Date {

    return new Date(
      data.getFullYear(),
      data.getMonth(),
      data.getDate()
    );
  }

  mesmaData(
    data1: Date | null,
    data2: Date | null
  ): boolean {

    if (!data1 || !data2) {
      return false;
    }

    return (
      data1.getFullYear() === data2.getFullYear() &&
      data1.getMonth() === data2.getMonth() &&
      data1.getDate() === data2.getDate()
    );
  }

  formatarData(data: Date | null): string {

    if (!data) {
      return '';
    }

    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).format(data);
  }

  formatarDataBackend(data: Date): string {

    const ano = data.getFullYear();

    const mes = String(
      data.getMonth() + 1
    ).padStart(2, '0');

    const dia = String(
      data.getDate()
    ).padStart(2, '0');

    return `${ano}-${mes}-${dia}`;
  }

  private calcularQuantidadeNoites(
    entrada: Date,
    saida: Date
  ): number {

    // UTC evita distorções em mudanças de horário.
    const inicio = Date.UTC(
      entrada.getFullYear(),
      entrada.getMonth(),
      entrada.getDate()
    );

    const fim = Date.UTC(
      saida.getFullYear(),
      saida.getMonth(),
      saida.getDate()
    );

    return Math.round(
      (fim - inicio) / 86400000
    );
  }

  get quantidadeNoites(): number {

    if (!this.dataEntrada || !this.dataSaida) {
      return 0;
    }

    return this.calcularQuantidadeNoites(
      this.dataEntrada,
      this.dataSaida
    );
  }

  // =====================================================
  // CÁLCULO DE TARIFAS
  // =====================================================

  private obterDiaSemana(data: Date): string {

    const dias = [
      'DOMINGO',
      'SEGUNDA',
      'TERCA',
      'QUARTA',
      'QUINTA',
      'SEXTA',
      'SABADO'
    ];

    return dias[data.getDay()];
  }

  private calcularValorTotal(): number {

    if (
      !this.dataEntrada ||
      !this.dataSaida ||
      !this.quarto
    ) {
      return 0;
    }

    if (
      this.quantidadeNoites < this.minimoNoitesSelecionado
    ) {
      return 0;
    }

    const quantidadeHospedes = this.adultos;

    if (
      quantidadeHospedes < 1 ||
      this.totalHospedes > this.quarto.capacidade
    ) {
      return 0;
    }

    const valorCrianca = Number(
      this.quarto.valorCrianca ?? 0
    );

    const valorAnimal = Number(
      this.quarto.valorAnimal ?? 0
    );

    const adicionalCriancas =
      valorCrianca * this.criancas;

    const adicionalAnimais =
      valorAnimal * this.animais;

    let total = 0;

    let dataAtual = this.normalizarData(
      this.dataEntrada
    );

    const dataFinal = this.normalizarData(
      this.dataSaida
    );

    while (dataAtual < dataFinal) {

      const dataString =
        this.formatarDataBackend(dataAtual);

      // Tarifa específica da data tem prioridade.
      const valorTarifaData =
        this.quarto.tarifasData?.[dataString]?.[
          quantidadeHospedes
          ];

      let valorTarifa: number;

      if (
        valorTarifaData !== undefined &&
        valorTarifaData !== null
      ) {

        valorTarifa = Number(valorTarifaData);

      } else {

        const diaSemana =
          this.obterDiaSemana(dataAtual);

        const tarifasDia =
          this.quarto.tarifas?.[diaSemana];

        const valorTarifaPadrao =
          tarifasDia?.[quantidadeHospedes];

        if (
          valorTarifaPadrao === undefined ||
          valorTarifaPadrao === null
        ) {
          return 0;
        }

        valorTarifa = Number(valorTarifaPadrao);
      }

      const valorDiaria =
        valorTarifa +
        adicionalCriancas +
        adicionalAnimais;

      total += valorDiaria;

      dataAtual = new Date(
        dataAtual.getFullYear(),
        dataAtual.getMonth(),
        dataAtual.getDate() + 1
      );
    }

    return total;
  }

  get valorTotal(): number {

    return this.calcularValorTotal();
  }

  // =====================================================
  // CONTINUAR RESERVA
  // =====================================================

  continuarReserva(): void {

    if (this.processando) {
      return;
    }

    // Impede continuar antes de carregar as regras.
    if (
      this.carregandoCalendario ||
      this.erroCalendario ||
      !this.regrasCarregadas ||
      !this.reservasCarregadas
    ) {

      this.mostrarAlerta(
        'warning',
        'Disponibilidade não confirmada',
        'Não foi possível concluir a consulta de disponibilidade e das regras de hospedagem.'
      );

      return;
    }

    if (!this.dataEntrada) {

      this.mostrarAlerta(
        'warning',
        'Check-in não selecionado',
        'Selecione a data de check-in.'
      );

      return;
    }

    if (
      this.normalizarData(this.dataEntrada) <
      this.dataMinimaDate
    ) {

      this.mostrarAlerta(
        'warning',
        'Check-in inválido',
        'O check-in deve ser a partir de amanhã.'
      );

      return;
    }

    if (this.dataEstaOcupada(this.dataEntrada)) {

      this.mostrarAlerta(
        'error',
        'Check-in indisponível',
        'A data de check-in selecionada está ocupada.'
      );

      return;
    }

    if (!this.dataSaida) {

      this.mostrarAlerta(
        'warning',
        'Check-out não selecionado',
        'Selecione a data de check-out.'
      );

      return;
    }

    if (this.dataSaida <= this.dataEntrada) {

      this.mostrarAlerta(
        'warning',
        'Datas inválidas',
        'O check-out deve ser posterior ao check-in.'
      );

      return;
    }

    // REGRA DE MÍNIMO DE NOITES
    const checkoutMinimo = this.checkoutMinimo;

    if (
      checkoutMinimo &&
      this.dataSaida < checkoutMinimo
    ) {

      this.mostrarAlerta(
        'warning',
        'Estadia mínima não atendida',
        `Para check-in em ${this.formatarData(this.dataEntrada)}, são necessárias pelo menos ${this.minimoNoitesSelecionado} noites. O check-out deve ser a partir de ${this.formatarData(checkoutMinimo)}.`
      );

      return;
    }

    if (
      this.periodoPossuiConflito(
        this.dataEntrada,
        this.dataSaida
      )
    ) {

      this.mostrarAlerta(
        'error',
        'Período indisponível',
        'As datas selecionadas possuem conflito com outra reserva.'
      );

      return;
    }

    if (this.adultos < 1) {

      this.mostrarAlerta(
        'warning',
        'Hóspede obrigatório',
        'É necessário ter pelo menos 1 adulto.'
      );

      return;
    }

    const quantidadeHospedes = this.totalHospedes;

    if (
      quantidadeHospedes < 1 ||
      (this.quarto &&
        quantidadeHospedes > this.quarto.capacidade)
    ) {

      this.mostrarAlerta(
        'warning',
        'Capacidade excedida',
        `Esta acomodação permite no máximo ${this.quarto?.capacidade ?? 0} hóspedes.`
      );

      return;
    }

    const valorTotal = this.calcularValorTotal();

    if (valorTotal <= 0) {

      this.mostrarAlerta(
        'error',
        'Tarifa indisponível',
        'Não foi possível calcular o valor da hospedagem para as datas e hóspedes selecionados.'
      );

      return;
    }

    const checkIn = this.formatarDataBackend(
      this.dataEntrada
    );

    const checkOut = this.formatarDataBackend(
      this.dataSaida
    );

    this.processando = true;

    this.checkoutService
      .verificarDisponibilidade(
        this.quartoId,
        checkIn,
        checkOut
      )
      .subscribe({

        next: (resposta) => {

          this.processando = false;

          if (!resposta.disponivel) {

            this.mostrarAlerta(
              'error',
              'Quarto indisponível',
              'O quarto não está disponível para o período informado. Escolha outras datas.'
            );

            this.carregarDatasOcupadas();
            return;
          }

          const quantidadeNoites = this.quantidadeNoites;

          this.checkoutService.atualizar({
            quartoId: this.quartoId,
            quartoNome: this.quarto?.nome,
            quartoImagem: this.imagensCabana[0],
            checkIn,
            checkOut,
            adultos: this.adultos,
            criancas: this.criancas,
            animais: this.animais,
            quantidadeHospedes,
            quantidadeNoites,
            valorTotal
          });

          this.router.navigate([
            '/checkout/hospedes'
          ]);

          this.cdr.detectChanges();
        },

        error: () => {

          this.processando = false;

          this.mostrarAlerta(
            'error',
            'Erro ao verificar disponibilidade',
            'Não foi possível verificar a disponibilidade do quarto. Tente novamente.'
          );

          this.cdr.detectChanges();
        }
      });
  }

  // =====================================================
  // ALERTAS
  // =====================================================

  private mostrarAlerta(
    icon: 'success' | 'error' | 'warning' | 'info' | 'question',
    title: string,
    text: string
  ): void {

    Swal.fire({
      icon,
      title,
      text,
      confirmButtonText: 'OK',
      confirmButtonColor: '#596238',
      customClass: {
        popup: 'swal-cabana'
      }
    });
  }
}
